import {Component, computed, inject, input} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {Divider} from 'primeng/divider';
import {TaxStore} from '../../services/tax-store';

@Component({
  selector: 'elcia-amount-recap',
  imports: [DecimalPipe, TranslatePipe, Divider],
  templateUrl: './amount-recap.component.html',
  styleUrl: './amount-recap.component.scss',
})
export class AmountRecap {
  invoiceLines = input.required<InvoiceLineAmount[]>();
  private taxes = inject(TaxStore).taxes;

  totalWithoutTaxes = computed(() =>
    this.invoiceLines().reduce((sum, l) => sum + l.quantity * l.unitPrice, 0)
  );

  taxSubtotals = computed(() => {
    const taxMap = new Map(this.taxes().map(t => [t.id, t]));
    const groups = new Map<number, { name: string; rate: number; base: number }>();
    for (const line of this.invoiceLines()) {
      const tax = taxMap.get(line.taxId);
      if (!tax) continue;
      const lineAmount = line.quantity * line.unitPrice;
      const existing = groups.get(line.taxId);
      if (existing) {
        existing.base += lineAmount;
      } else {
        groups.set(line.taxId, {name: tax.nameFr, rate: tax.rate, base: lineAmount});
      }
    }
    return Array.from(groups.values()).map(g => ({...g, amount: g.base * (g.rate / 100)}));
  });

  totalWithTaxes = computed(() =>
    this.totalWithoutTaxes() + this.taxSubtotals().reduce((sum, t) => sum + t.amount, 0)
  );
}

export interface InvoiceLineAmount {
  quantity: number;
  unitPrice: number;
  taxId: number;
}
